export default {
  info () {
    let args = [...arguments]
    // console.log.apply(null, args)
  },
  debug () {
    let args = [...arguments]
    // console.debug.apply(null, args)
  },
  error () {
    let args = [...arguments]
    // console.error.apply(null, args)
  }
}